import { render } from "./WhyItMatter.vue?vue&type=template&id=607e21a0&scoped=true"
import script from "./WhyItMatter.vue?vue&type=script&lang=js"
export * from "./WhyItMatter.vue?vue&type=script&lang=js"

import "./WhyItMatter.vue?vue&type=style&index=0&id=607e21a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e21a0"]])

export default __exports__